import { useEffect, useState } from "react";
import { sleep } from "../helpers/asyncronicFunction";
import { MOVER, DESPLEGAR, MOVERREVES } from "../hooks/useMovesRandom";
import Style from "./Style.module.scss";

const useFigure = (
  lifeTime: number,
  onNoPress?: () => void,
  onClick?: () => void,
  move?: string
): {
  pressFigure: () => void;
  moveStyle: () => string;
  displayed: boolean;
  finishTime: boolean;
  clicked: boolean;
} => {
  const [clicked, setClicked] = useState(false); //fue clickeado?
  const [displayed, setDisplay] = useState(true); //esta mostrandose?
  const [finishTime, setfinishTime] = useState(false);
  const [timerComponent, setTimerComponent] = useState(lifeTime); //tiempo maximo que se despliega el componente

  useEffect(() => {
    const asyncCheck = async () => {
      if (timerComponent > 0) {
        sleep(() => !clicked && setTimerComponent(timerComponent - 1));
      } else {
        if (displayed) {
          setfinishTime(true);
          sleep(() => {
            setClicked(true);
            onNoPress?.();
          });
        }
      }
    };
    asyncCheck();
  }, [timerComponent]);

  const pressFigure = () => {
    if (displayed && !finishTime) {
      setDisplay(false);
      setTimeout(() => {
        setClicked(true);
        onClick?.();
      }, 2000);
    }
  };

  const moveStyle = () => {
    switch (move) {
      case DESPLEGAR:
        return Style.displayFigure;
      case MOVER:
        return Style.moveFigure;
      case MOVERREVES:
        return Style.reverseMoveFIgure;
      default:
        return "";
    }
  };

  return { pressFigure, moveStyle, displayed, finishTime, clicked };
};

export default useFigure;
